<template>
  <div>
    <p v-if="invalidCeremony" role="alert" class="max-w-lg mx-auto px-4 mt-8 text-red-700">
      This registration link is invalid or the ceremony is no longer available.
      Please contact your university for the correct link.
    </p>
    <title-page
      title="Your Graduation Made Easy"
      v-if="state == 'title' && !headless && !invalidCeremony"
      @submit="state = 'one'"
      :organiserName="organiser.name"
    />
    <RegistrationForm
      v-if="state == 'one' && !invalidCeremony"
      :events="events"
      :event="selectedCeremonyId"
      :key="selectedCeremonyId"
      @submit="submitStepOne"
      :additionalFieldsInput="additionalFieldsInput"
      :organiserSlug="organiser.slug"
      :submitting="isLoading"
    />
    <finished
      v-if="state == 'finished'"
      :name="firstname(personalDetails.name)"
      :registrationID="this.registrationID"
    />
  </div>
</template>

<script>
import RegistrationForm from "./Registration/RegistrationForm.vue";
import Finished from "./Registration/Finished.vue";
import axios from "axios";
import TitlePage from "./TitlePage.vue";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import {endSession, trackEvent} from "../Analytics.vue"

export default {
  name: "Form",
  props: {
    organiser: Object,
    additionalFieldsInput: Array,
  },
  components: {
    TitlePage,
    RegistrationForm,
    Finished,
  },
  data: function () {
    return {
      state: this.$route.query.headless !== undefined ? "one" : "title",
      personalDetails: {},
      id: null,
      isLoading: false,
      registrationID: ""
    };
  },
  computed: {
    events() {
      const ceremonies = this.organiser.ceremonies || [];
      const ceremonyId = this.$route.query.ceremony_id;
      if (ceremonyId === undefined) return ceremonies;
      return ceremonies.filter((ceremony) => ceremony.id === ceremonyId);
    },
    invalidCeremony() {
      return this.$route.query.ceremony_id !== undefined && this.events.length !== 1;
    },
    selectedCeremonyId() {
      return this.$route.query.ceremony_id !== undefined && !this.invalidCeremony
        ? this.events[0].id
        : "";
    },
    headless() {
      return this.$route.query.headless !== undefined;
    },
  },
  methods: {
    firstname(name) {
      return name.split(" ")[0];
    },
    submitStepOne(formData) {
      if (this.invalidCeremony || !this.events.some((ceremony) => ceremony.id === formData.event)) {
        return;
      }
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      this.personalDetails = formData;
      this.personalDetails.organisation = this.organiser.name;
      console.log(formData);

      var mappedAdditionalFields = {}
      formData["additionalFields"].forEach((item) => {
        mappedAdditionalFields[item["name"]] = item["value"];
      });

      axios
        .post(
          "/registrations",
          {
            name: formData["name"],
            email: formData["email"],
            ceremony: formData["event"],
            additionalFields: mappedAdditionalFields,
          }
        )
        .then((r) => {
          console.log(r.data);
          this.registrationID = r.data.id;
          trackEvent(this.$route.path, {label: "REGISTRATION_SUBMITTED", registration_id: this.registrationID, type: "FREE"})
          const page_mode = this.$route.query.mode;
          if (r.data.ceremony_ready && page_mode != "live") {
            this.$router.push(`/thumbnails/${this.$route.params.uni}/${r.data.id}`)
          }
        })
        .then(() => {
          this.state = "finished";
          endSession();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    submit() {
      return true;
    },
  },
};
</script>
